
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const InformationCompanyComponent = lazy(() => import('./containers/InformationServiceContainer'));

const route = [
  {
    path: ROUTERS.INFORMATION_SERVICE_COMPANY,
    title: 'Information Company',
    exact: true,
    public: false,
    component: <InformationCompanyComponent />
  },
  {
    path: ROUTERS.INFORMATION_SERVICE_TERM,
    title: 'Information Term',
    exact: true,
    // public: false,
    component: <InformationCompanyComponent />
  },
  {
    path: ROUTERS.INFORMATION_SERVICE_POLICY,
    title: 'Information Policy',
    exact: true,
    // public: false,
    component: <InformationCompanyComponent />
  },
];

export default route;